import React, { useContext } from 'react';
import { ProductContext } from "../../../stores/session";
import GenericDataRow from "../../../GenericPageElements/GenericDataRow";

export default function FileDateSelect({ fileDates, selectedFileDate, setSelectedFileDate, data }) {
    const { isWorkflow } = useContext(ProductContext)
    return [
        <GenericDataRow title={"File Date"} contentColour={'var(--white)'} contentStyle={ data?.Refresh_Date ? { backgroundColor: '#ececec', fontSize: '13px' } : {}}>
            {
                isWorkflow ?
                    <select style={{ width: '100%', border: 'none' }} onChange={(event) => setSelectedFileDate(event.target.value)} value={selectedFileDate}>
                        <option value=''>All Dates</option>
                        {
                            fileDates.map(date => {
                                return (
                                    <option value={date.raw}>{date.pretty}</option>
                                )
                            })
                        }
                    </select>
                :
                    data?.Refresh_Date?.substring(0, data.Refresh_Date.indexOf('T'))
            }
        </GenericDataRow>
    ]
}